var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(!_vm.isMobile)?[_c('event-item-list',{attrs:{"event":_vm.event},on:{"checkDuplicate":function($event){return _vm.$emit('checkDuplicate')}}})]:[_c('event-item-mobile',{attrs:{"event":_vm.event}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }